import React from 'react';

// Kleines Schweizer-Kreuz-Icon
function SwissCross({ className = 'h-7 w-7' }) {
  return (
    <span className={`inline-flex items-center justify-center rounded-md bg-[#D52B1E] ${className}`} aria-hidden="true">
      <svg viewBox="0 0 20 20" className="h-4/6 w-4/6" fill="#fff">
        <rect x="8" y="3" width="4" height="14" />
        <rect x="3" y="8" width="14" height="4" />
      </svg>
    </span>
  );
}

export default SwissCross;